export default __webpack_public_path__ + "static/media/i.115f19d3.png";